export default __webpack_public_path__ + "static/media/Visual 11.ef6ce1a9.png";